module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAAGzs1ytAAAAAXNSR0IArs4c6QAAAHpJREFUOBHtUkEOwCAI072G/7+G32zrshJFZ7LDErLABbBYoVJUdS+nwW8IaF1ywUDWZZVsIlJZDt+T4eS2R6CjIu20+otDe519ciDk7IbYtAGC3gcp/v2AQXQO0sbw3X4t2/1uMb/rLYb41Xz+8ipPYlMnpUgpTAELDk8QNAueSKmGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/image/pause.png
// module id = 576
// module chunks = 0